// Reusable US Letter (landscape) Target packing list (DOSS PO-v4 design); mapped identity.
// Generated by scripts/wms/generate.ts for PHP-422. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomTargetPackingListFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  customerBrandSubtitle: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  targetDcCode: yup.string().nullable().optional(),
  poDate: yup.string().nullable().optional(),
  fromName: yup.string().nullable().optional(),
  fromAddress: yup.string().nullable().optional(),
  targetVendorNumber: yup.string().nullable().optional(),
  shipToName: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        lineNumber: yup.number().nullable().optional(),
        vendorSku: yup.string().nullable().optional(),
        productDescription: yup.string().nullable().optional(),
        upcEan: yup.string().nullable().optional(),
        dpci: yup.string().nullable().optional(),
        casepacks: yup.string().nullable().optional(),
        unitsPerCasepack: yup.string().nullable().optional(),
        totalUnits: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type BiomTargetPackingListFileData = yup.InferType<
  typeof biomTargetPackingListFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomTargetPackingListFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomTargetPackingListFileMappings: RequiredFileData = {
  customerDisplayName: 'd13fcd75-5d83-4441-9e96-7638abb24b73',
  customerBrandSubtitle: '37ae8b91-8dd8-4b20-bce5-366e97eebcd4',
  poNumber: '427bfb70-6214-41d9-b00e-d5253d00461b',
  targetDcCode: '9488c8c2-ad0d-4383-9820-521f182ffe76',
  poDate: '33b7eb7c-a4a0-4234-ad5a-4d1252bab633',
  fromName: 'b6983ff0-e8f3-4dfd-b3e0-37b93aab038e',
  fromAddress: 'd34d0365-9ace-4619-ada9-80cd49d66094',
  targetVendorNumber: '12b5ade2-3983-4e26-b66c-69eb1e20c079',
  shipToName: '9f7c9a86-61bd-4c0a-8a92-95f615caf6ec',
  shipToAddress: '7f602d50-bc4c-4067-8243-a4e3252493b1',
  items: [
    {
      lineNumber: null,
      vendorSku: '9035ae08-e205-40b7-b3be-cefa8b8ce7b2',
      productDescription: 'f035192c-e2f7-40f7-8aef-888039b65e48',
      upcEan: '382bfc66-4f13-4e9a-836c-d972f3156c67',
      dpci: '6030fa5c-9ee8-4179-93df-71912b8be0f4',
      casepacks: '72cbb308-1cbf-4208-b14a-dde9699e7ac7',
      unitsPerCasepack: 'f12a3e09-cd88-4857-9090-796c3d60d4ac',
      totalUnits: '0e776b2b-74c8-4eed-a2de-8a7081b27b5c',
    },
  ],
}
